<!--
  Escalera de tramos. Todo es informativo: la tasa final la confirma el
  cotizador y el monto de acá no viaja a ningún envío.
-->
<!--
  Teaser de una línea (solo `posicion="arriba"` y bajo 768 px): lo único que
  va arriba del botón de operar en el celular. La escalera completa la pinta
  la instancia `posicion="abajo"`, debajo del botón.
-->
<div class="et-teaser" *ngIf="posicion === 'arriba' && escalera?.length && actual" role="status">
  <ng-container *ngIf="falta as f; else teaserSinFalta">
    <span class="et-teaser__txt">
      Tramo {{ indice + 1 }} de {{ n }} · Te faltan <b>{{ aprox }}{{ dinero(f.falta, moneda) }}</b>
    </span>
    <button
      *ngIf="montoUsar as mu"
      type="button"
      class="et-teaser__usar"
      [attr.aria-label]="'Usar ' + montoExacto(mu)"
      (click)="usar()"
    >Usar</button>
  </ng-container>
  <ng-template #teaserSinFalta>
    <span class="et-teaser__txt" *ngIf="enLaMejor && montoN > 0; else teaserTramo">
      <i aria-hidden="true">★</i> Ya tienes la <b>mejor tasa</b>
    </span>
    <ng-template #teaserTramo>
      <span class="et-teaser__txt">
        Tramo {{ indice + 1 }} de {{ n }} · Tu tasa <b>{{ tasa(tasaTu) }}<ng-container *ngIf="simbolo"> {{ simbolo }}</ng-container></b>
      </span>
    </ng-template>
  </ng-template>
</div>

<div
  class="et"
  [class.et--compacta]="compacta"
  [class.et--arriba]="posicion === 'arriba'"
  [class.et--abajo]="posicion === 'abajo'"
  *ngIf="escalera?.length && actual as a"
>

  <!-- Tu tasa · Tramo k de N -->
  <div class="et__tu" [id]="idTu">
    <small>Tu tasa</small>
    <b>{{ tasa(tasaTu) }}<ng-container *ngIf="simbolo"> {{ simbolo }}</ng-container></b>
    <em>Tramo {{ indice + 1 }} de {{ n }}</em>
  </div>

  <!-- Barra con «Estás aquí» -->
  <div class="et__esc" aria-hidden="true">
    <span class="et__marca" [ngStyle]="marca">Estás aquí</span>
    <div class="et__barra">
      <i
        *ngFor="let e of escalera; let k = index; trackBy: trackEscalon"
        [class.lleno]="k < indice"
        [class.aqui]="k === indice"
        [class.mejor]="k === n - 1"
      ></i>
    </div>
    <div class="et__ejes">
      <span>{{ ejeDesde }}</span>
      <span>{{ ejeHasta }}</span>
    </div>
  </div>

  <!-- Ahorro frente a la base (compacta: si además falta para la próxima, va en la lista) -->
  <div class="et__msg et__msg--ok" role="status" *ngIf="(compacta && falta) ? null : ahorro as g">
    <i aria-hidden="true">✓</i>
    <span *ngIf="g.tipo === 'PAGA_MENOS'">
      Con este monto <b>ahorras {{ dinero(g.valor, g.moneda) }}</b> frente a la tasa base.
    </span>
    <span *ngIf="g.tipo === 'RECIBE_MAS'">
      Con este monto <b>recibes {{ dinero(g.valor, g.moneda) }} más</b> que con la tasa base.
    </span>
  </div>

  <!-- Lo que falta para la próxima tasa -->
  <div class="et__msg et__msg--next" *ngIf="falta as f">
    <i aria-hidden="true">↑</i>
    <span>
      Te faltan <b>{{ aprox }}{{ dinero(f.falta, moneda) }}</b> para la próxima tasa
      (<b>{{ tasa(f.siguiente.tasa) }}</b>).
      <ng-container *ngIf="!compacta && ahorroSiguiente as gn">
        <ng-container *ngIf="gn.valor > 0.004">
          Con {{ aprox }}{{ dinero(f.montoSiguiente, moneda) }}
          {{ gn.tipo === 'PAGA_MENOS' ? 'ahorrarías' : 'recibirías' }}
          {{ dinero(gn.valor, gn.moneda) }}{{ gn.tipo === 'PAGA_MENOS' ? '' : ' más' }}.
        </ng-container>
      </ng-container>
    </span>
    <!-- Solo en las calculadoras: escribe el monto en el campo; no confirma nada. -->
    <button
      *ngIf="montoUsar as mu"
      type="button"
      class="et__usar"
      (click)="usar()"
    >Usar {{ montoExacto(mu) }}</button>
  </div>

  <div class="et__msg et__msg--top" *ngIf="enLaMejor && montoN > 0">
    <i aria-hidden="true">★</i>
    <span>Ya tienes la <b>mejor tasa</b>.</span>
  </div>

  <!-- Todos los tramos, plegados -->
  <details class="et__lista">
    <summary>
      <span>Ver los {{ n }} tramos</span>
      <span class="et__chev" aria-hidden="true"></span>
    </summary>
    <!-- Compacta (calculadoras): lo que no entra arriba sin empujar el botón -->
    <div class="et__extra" *ngIf="compacta && falta as f">
      <p *ngIf="ahorro as g">
        Con este monto
        <b>{{ g.tipo === 'PAGA_MENOS' ? 'ahorras' : 'recibes' }} {{ dinero(g.valor, g.moneda) }}{{ g.tipo === 'PAGA_MENOS' ? '' : ' más' }}</b>
        frente a la tasa base.
      </p>
      <p *ngIf="ahorroSiguiente as gn">
        <ng-container *ngIf="gn.valor > 0.004">
          Con {{ aprox }}{{ dinero(f.montoSiguiente, moneda) }}
          {{ gn.tipo === 'PAGA_MENOS' ? 'ahorrarías' : 'recibirías' }}
          {{ dinero(gn.valor, gn.moneda) }}{{ gn.tipo === 'PAGA_MENOS' ? '' : ' más' }}.
        </ng-container>
      </p>
    </div>
    <ol>
      <li
        *ngFor="let e of escalera; let k = index; trackBy: trackEscalon"
        [class.aqui]="k === indice"
      >
        <span class="d">{{ rotulo(e) }}</span>
        <span class="t">{{ tasa(e.tasa) }}</span>
        <span class="b" *ngIf="k === indice || e.mejor">
          <span class="pill pill--tu" *ngIf="k === indice">Tú</span>
          <span class="pill pill--mj" *ngIf="e.mejor">Mejor</span>
        </span>
      </li>
    </ol>
    <p>
      <ng-container *ngIf="unidad">{{ unidad }}. </ng-container>
      <ng-container *ngIf="aproximado">Los montos en {{ moneda === 'VES' ? 'Bs.' : moneda }} son aproximados. </ng-container>
      La tasa final la confirma el cotizador.
    </p>
  </details>
</div>
